import { graphql, readInlineData } from "react-relay";

import type { utilitiesGetHasArticleSpeechArticle$key } from "scmp-app/queries/__generated__/utilitiesGetHasArticleSpeechArticle.graphql";

export const getHasArticleSpeech = (
  reference: utilitiesGetHasArticleSpeechArticle$key,
): boolean => {
  const article = readInlineData(
    graphql`
      fragment utilitiesGetHasArticleSpeechArticle on Article @inline {
        articleSpeeches {
          url
        }
      }
    `,
    reference,
  );
  return (article.articleSpeeches ?? []).some(speech => Boolean(speech?.url));
};
